import React from 'react';
import { LoadingSkeleton } from '@helpcenter/loading';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
import { token } from '@atlaskit/tokens';

const MultiHcDropdownLoader = () => (
    <LoadingSkeleton height={32} backgroundColor={token('color.skeleton.subtle', '#F4F5F7')} />
);

export const MultiHcDropdown = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "multi-hc-dropdown" */ './hocs')),
    LoadingSkeleton: MultiHcDropdownLoader,
});
